/** Droits d’écriture des entités métier — identiques en local et en remote. */

export type EntityWriteResource =
  | 'salaries'
  | 'bulletins'
  | 'ecritures'
  | 'factures'
  | 'centres-analytiques'
  | 'tenant-profile'
  | 'users';

export type EntityWriteAction = 'create' | 'update' | 'delete';

const RH = ['admin', 'rh', 'super_admin'] as const;
const COMPTA = ['admin', 'rh', 'comptable', 'super_admin'] as const;
const ADMIN = ['admin', 'super_admin'] as const;

const ROLES: Record<EntityWriteResource, Record<EntityWriteAction, readonly string[]>> = {
  salaries: { create: RH, update: RH, delete: RH },
  bulletins: { create: RH, update: COMPTA, delete: RH },
  ecritures: { create: COMPTA, update: COMPTA, delete: COMPTA },
  factures: { create: COMPTA, update: COMPTA, delete: COMPTA },
  'centres-analytiques': { create: COMPTA, update: COMPTA, delete: COMPTA },
  'tenant-profile': { create: RH, update: RH, delete: RH },
  users: { create: ADMIN, update: ADMIN, delete: ADMIN },
};

export function canWriteEntity(
  role: string | undefined,
  resource: EntityWriteResource,
  action: EntityWriteAction,
): boolean {
  if (!role) return false;
  return ROLES[resource][action].includes(role);
}
